
// @ts-nocheck


export const localeCodes =  [
  "it",
  "en",
  "es"
]

export const localeLoaders = {
  it: [
    {
      key: "locale_it_46js_cce9fa1e",
      load: () => import("#nuxt-i18n/cce9fa1e" /* webpackChunkName: "locale_it_46js_cce9fa1e" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46js_eff281f9",
      load: () => import("#nuxt-i18n/eff281f9" /* webpackChunkName: "locale_en_46js_eff281f9" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46js_66bac2e6",
      load: () => import("#nuxt-i18n/66bac2e6" /* webpackChunkName: "locale_es_46js_66bac2e6" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      name: "Italiano",
      code: "it",
      language: "it-IT",
      files: [
        {
          path: "/opt/build/repo/i18n/locales/it.js",
          cache: undefined
        }
      ]
    },
    {
      name: "English",
      code: "en",
      language: "en-US",
      files: [
        {
          path: "/opt/build/repo/i18n/locales/en.js",
          cache: undefined
        }
      ]
    },
    {
      name: "Español",
      code: "es",
      language: "es-ES",
      files: [
        {
          path: "/opt/build/repo/i18n/locales/es.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "it",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://lorena.ramonda.me",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    name: "Italiano",
    code: "it",
    language: "it-IT",
    files: [
      {
        path: "/opt/build/repo/i18n/locales/it.js",
        cache: undefined
      }
    ]
  },
  {
    name: "English",
    code: "en",
    language: "en-US",
    files: [
      {
        path: "/opt/build/repo/i18n/locales/en.js",
        cache: undefined
      }
    ]
  },
  {
    name: "Español",
    code: "es",
    language: "es-ES",
    files: [
      {
        path: "/opt/build/repo/i18n/locales/es.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/